import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.css']
})
export class InputFieldComponent implements OnInit, OnChanges, OnDestroy {
  @Output() formGenerated = new EventEmitter<any>();
  @Input() fieldDetails: any;
  userSubmit: boolean = false;
  form = new FormGroup({});
  
  private _subscription: Subscription;

  constructor(private _dataSer: DataService) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'reportSubmit') {
        this._onSubmit()
      }
    });
  }

  ngOnInit(): void {
  }
  ngOnDestroy(): void {
    this._subscription?.unsubscribe(); 
  }
  ngOnChanges(): any {
    this.form = new FormGroup({});
    this.form.addControl(
      this.fieldDetails?.id,
      new FormControl('', this.fieldDetails?.required ? Validators.required : null)
    );
  }

  get formValues() {
    return this.form.controls;
  }

  private _onSubmit(actionType: string = 'submit') {
    if (actionType === 'submit') {
      this.userSubmit = true;
      if (this.form.valid) {
        this.formGenerated.emit(this.form.value);
      }
    }
    // else if (actionType === 'clear') {
    //   this.form.reset();
    //   this.formGenerated.emit({ formValue: this.form.value });
    // } else {
    //   this.formGenerated.emit({ formValue: null });
    // }
  }

}
